export const LOGIN_METADATA_COOKIE_NAME = 'hs_login_metadata';